define([
    "angular",
    "angular-ui-router",
    "angular-bootstrap",
    "front-end-web-commons"
], function (angular) {
    "use strict";

    /**
     * @ngdoc overview
     * @name gatewayModule
     * @description
     *
     * Módulo com funcionalidades de gerenciamento de acesso de integrações.
     * */
    return angular.module("gatewayModule", [
        "ui.router",
        "ui.bootstrap",
        "filterModule",
        "remoteModule",
        "entityDTOModule",
        "nlgTableModule",
        "nlgPortletModule"
    ]);
});